type PdfUrlPayload = {
  pdfUrl?: unknown;
};

export const extractPdfUrl = (payload: unknown): string | undefined => {
  if (typeof payload !== 'object' || payload === null || !('pdfUrl' in payload)) {
    return undefined;
  }

  const {pdfUrl} = payload as PdfUrlPayload;
  return typeof pdfUrl === 'string' && pdfUrl.trim() ? pdfUrl : undefined;
};

export const openPdfUrl = (pdfUrl?: string) => {
  if (!pdfUrl) return;

  window.open(pdfUrl, '_blank', 'noopener,noreferrer');
};
